<template>
  <div id="home">
    <header>
      <div class="header">
        <!-- 登录/注销按钮 -->
        <button v-if="!hasToken" class="login-button" @click="goToLogin">登录</button>
        <button v-else class="login-button" @click="logout">注销登录</button>
      </div>
      <h1>生活小妙招</h1>
    </header>

    <div class="container">
      <!-- 功能列表 -->
      <div class="section">
        <h2>实用工具</h2>
        <ul>
          <li><router-link to="/pdf2word">PDF 转 Word</router-link>：将 PDF 文档快速转换为 Word 文件，方便编辑和修改。</li>
          <li><router-link to="/document">文档编辑</router-link>：提供分目录进行在线 word 文档的查看和编辑，并且支持目录的编辑。</li>
          <li><router-link to="/marketPrices">全国各地市场价格</router-link>：提供全国各地市场水果、蔬菜、肉类等产品价格查询。</li>
<!--          <li><router-link to="/test">测试页面</router-link>：测试。</li>-->
        </ul>
      </div>

      <!-- 天气模块 -->
      <div class="weather-module" v-if="weatherData">
        <h2>当前天气 & 未来预报</h2>
        <div class="current-weather">
          <p>位置：{{ weatherData.city }} {{ weatherData.forecasts[0].adcode }}</p>
          <div class="temp-info">
            <img
                :src="getWeatherIcon(weatherData.lives[0].weather, true)"
                alt="weather icon"
                class="weather-icon"
            />
            <span class="temp">{{ weatherData.lives[0].temperature }}°C</span>
          </div>
          <p>天气状况：{{ weatherData.lives[0].weather }}</p>
          <p>风力风向：{{ weatherData.lives[0].winddirection }} {{ weatherData.lives[0].windpower }}</p>
        </div>

        <div class="forecast-list-wrapper">
          <div class="forecast-list">
            <h3>未来四天预报</h3>
            <ul>
              <li
                  v-for="(item, index) in weatherData.forecasts[0].casts"
                  :key="index"
                  :class="getWeatherBackgroundClass(item.dayweather)"
              >
                <p>日期：{{ item.date }}</p>
                <div class="forecast-item-info">
                  <img
                      :src="getWeatherIcon(item.dayweather,true)"
                      alt="weather icon"
                      class="forecast-icon"
                  />
                  <span>白天：{{ item.dayweather }} 温度：{{ item.daytemp }}°C</span>
                </div>
                <div class="forecast-item-info">
                  <img
                      :src="getWeatherIcon(item.nightweather,false)"
                      alt="weather icon"
                      class="forecast-icon"
                  />
                  <span>夜间：{{ item.nightweather }} 温度：{{ item.nighttemp }}°C</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 如果能够获取到用户的经纬度，显示地图 -->
      <div v-if="latitude && longitude" class="map-container">
        <h2>当前位置地图</h2>
        <div id="map"></div>
      </div>
    </div>

    <!-- 底部备案信息 -->
    <div class="footer">
      <div class="footer">
        <a href="https://beian.miit.gov.cn" target="_blank">京ICP备2024089795号</a>
        <span>|</span>
        <a
            href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011402054371"
            target="_blank"
        >
          京公网安备11011402054371号
        </a>
        <span v-if="userIp">
          | 您的 IP：{{ userIp }} {{ location ? `（${location}）` : '' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import axios from 'axios';
import AMapLoader from "@amap/amap-jsapi-loader";
import coordtransform from 'coordtransform';

export default {
  name: 'Home',
  data() {
    return {
      amapKey: 'fce6f04fdb2f74618edaaeaf4276e3e0', // 可放置自己的高德key或留空
      hasToken: false,
      userIp: null,
      adcode: null,
      location: null,
      weatherData: null,
      // 经纬度
      latitude: null,
      longitude: null,
      // 天气图标映射
      weatherIconMap: {
        '晴': require('@/assets/icons/晴.png'),
        '晴见多云': require('@/assets/icons/晴见多云.png'),
        '晴间多云': require('@/assets/icons/晴见多云.png'),
        '多云': require('@/assets/icons/晴见多云.png'),
        '雨': require('@/assets/icons/小雨.png'),
        '阵雨': require('@/assets/icons/阵雨.png'),
        '小雨': require('@/assets/icons/小雨.png'),
        '中雨': require('@/assets/icons/中雨.png'),
        '大雨': require('@/assets/icons/大雨.png'),
        '暴雨': require('@/assets/icons/暴雨.png'),
        '雪': require('@/assets/icons/雪.png'),
        '阵雪': require('@/assets/icons/阵雪.png'),
        '小雪': require('@/assets/icons/小雪.png'),
        '中雪': require('@/assets/icons/中雪.png'),
        '大雪': require('@/assets/icons/大雪.png'),
        '雨夹雪': require('@/assets/icons/雨夹雪.png'),
        '阴': require('@/assets/icons/阴.png'),
        '雾': require('@/assets/icons/雷阵雨.png'),
        '雷阵雨': require('@/assets/icons/雷阵雨.png'),
      },
      // 天气背景映射
      weatherBackgroundMap: {
        '晴': 'sunny-bg',
        '多云': 'cloudy-bg',
        '阴': 'cloudy-bg',
        '雾': 'cloudy-bg',
        '雨': 'rainy-bg',
        '雷阵雨': 'rainy-bg',
        '小雨': 'rainy-bg',
        '中雨': 'rainy-bg',
        '大雨': 'rainy-bg',
        '暴雨': 'rainy-bg',
        '雨夹雪': 'snowy-bg',
        '雪': 'snowy-bg',
        '小雪': 'snowy-bg',
        '中雪': 'snowy-bg',
        '大雪': 'snowy-bg',
      },
    };
  },
  created() {
    // 检查是否有 token
    this.hasToken = !!Cookies.get('token');
    // 获取 IP 和天气
    this.fetchUserIpAndLocation();
    // 获取用户地理位置
    this.getUserLocation();
  },
  methods: {
    // 获取 IP 和天气信息
    async fetchUserIpAndLocation() {
      try {
        // 1. 获取 IP（经本地代理访问百度 IP 画像接口，浏览器直连会被 403）
        const ipResponse = await fetch('/baidu-ip/api/v1/ip-portrait/brief-info/local');
        const ipData = await ipResponse.json();
        this.userIp = ipData.data?.query_ip || '未知';
      } catch (error) {
        console.error('获取 IP 失败:', error);
        this.userIp = '未知';
      }
      try {
        // 2. 通过高德 IP 定位获取 adcode（用于天气查询）
        const geoResponse = await fetch(`https://restapi.amap.com/v3/ip?key=${this.amapKey}`);
        const geoData = await geoResponse.json();
        if (geoData.status === '1' && typeof geoData.adcode === 'string' && geoData.adcode) {
          this.adcode = geoData.adcode;
        }
      } catch (error) {
        console.error('获取 IP 定位失败:', error);
      }
    },
    // 获取用户浏览器定位
    getUserLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
              const latitude = position.coords.latitude;
              const longitude = position.coords.longitude;
              // 保存经纬度
              this.latitude = latitude;
              this.longitude = longitude;
              const [gcjLng, gcjLat] = coordtransform.wgs84togcj02(longitude, latitude);
              this.longitude = gcjLng;
              this.latitude = gcjLat;
              // 获取逆地理编码地址
              this.getAddressFromCoordinates(this.latitude, this.longitude);
              // 初始化地图
              this.$nextTick(() => {
                this.initMap();
              });
            },
            (error) => {
              console.error('获取位置信息失败:', error);
              this.location = '定位失败';
            },
            {timeout: 10000}
        );
      } else {
        console.error('浏览器不支持地理定位');
        this.location = '定位失败';
      }
    },
    // 逆地理编码，获取更具体的地址
    async getAddressFromCoordinates(latitude, longitude) {
      try {
        const response = await axios.get(`/api/gaode/geocodeRegeo?longitude=${longitude}&latitude=${latitude}`);
        this.location = response.data.data.regeocode.formatted_address;
        if (
            response.data.data &&
            response.data.data.regeocode &&
            response.data.data.regeocode.addressComponent &&
            response.data.data.regeocode.addressComponent.adcode
        ) {
          const amapResponse = await axios.get(
              `/api/gaode/weatherInfo?city=${response.data.data.regeocode.addressComponent.adcode}`
          );
          if (amapResponse.data.data) {
            this.weatherData = amapResponse.data.data;
            this.weatherData.city = amapResponse.data.data.forecasts[0].city;
          }
        }else {
          // 2. 根据 adcode 获取天气信息
          if (this.userIp !== '未知' && this.adcode) {
            const amapResponse = await axios.get(`/api/gaode/weatherInfo?city=${this.adcode}`);
            if (amapResponse.data.data) {
              this.weatherData = amapResponse.data.data;
              this.weatherData.city = amapResponse.data.data.forecasts[0].city;
            }
          }
        }
      } catch (error) {
        console.error('逆地理编码失败:', error);
        this.location = '定位失败';
      }
    },
    // 登录跳转
    goToLogin() {
      sessionStorage.setItem('redirectUrl', this.$route.fullPath);
      this.$router.push('/login');
    },
    // 注销
    logout() {
      Cookies.remove('token');
      this.hasToken = false;
    },
    // 获取天气图标
    getWeatherIcon(weather, isDay) {
      // 夜间多云特殊处理
      if (weather === '多云' && !isDay) {
        return require('@/assets/icons/夜间多云.png');
      }
      // 默认晴天图标
      return this.weatherIconMap[weather] || require('@/assets/icons/晴.png');
    },
    // 获取天气背景 CSS 类
    getWeatherBackgroundClass(weather) {
      return this.weatherBackgroundMap[weather] || '';
    },
    // 初始化高德地图
    initMap() {
      // 注意：经度在前，纬度在后
      AMapLoader.load({
        key: "42996bac22de47b7bf8ed4ad0b4370ff",
        version: "2.0",
        plugins: ["AMap.Geocoder"], // 需要用的插件，比如 Geocoder
      })
          .then((AMap) => {
            const map = new AMap.Map("map", {
              center: [this.longitude, this.latitude],
              zoom: 15,
            });
            new AMap.Marker({
              position: [this.longitude, this.latitude],
              map: map,
            });
          })
          .catch((e) => {
            console.error("高德地图加载失败", e);
          });
    },
  },
};
</script>

<style scoped>
/* 一些基础样式，可根据实际需求修改 */
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  background-color: #f5f5f5;
}

header {
  background-color: #4CAF50;
  color: white;
  padding: 20px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

h1 {
  margin: 0;
  font-size: 36px;
}

.container {
  max-width: 1200px;
  margin: 30px auto;
  padding: 20px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.section {
  text-align: center;
  margin-bottom: 40px;
}

.section h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 20px;
}

.section ul {
  list-style-type: none;
  padding: 0;
}

.section ul li {
  background-color: #e0f7fa;
  margin: 10px 0;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
  font-size: 18px;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  border-top: 1px solid #e0e0e0;
  text-align: center;
  font-size: 12px;
  color: #666;
  padding: 10px 0;
}

.footer a {
  color: #666;
  text-decoration: none;
  margin: 0 10px;
}

.login-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s;
  position: absolute;
  right: 20px;
  top: 20px;
}

.login-button:hover {
  background-color: #0056b3;
}

.weather-module {
  margin: 30px 0;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  text-align: center;
}

.current-weather p {
  margin: 10px 0;
  font-size: 16px;
  color: #333;
}

.temp-info {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 15px 0;
}

.temp {
  font-size: 24px;
  font-weight: bold;
  margin-left: 10px;
}

.weather-icon,
.forecast-icon {
  width: 48px;
  height: 48px;
}

.forecast-list-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.forecast-list h3 {
  margin: 20px 0 15px;
  color: #444;
}

.forecast-list ul {
  list-style: none;
  padding: 0;
}

.forecast-list li {
  margin: 15px 0;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.forecast-item-info {
  display: flex;
  align-items: center;
  margin: 5px 0;
}

.forecast-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

/* 天气背景示例 */
.sunny-bg {
  background-color: #fff3e0;
}

.cloudy-bg {
  background-color: #e0f7fa;
}

.rainy-bg {
  background-color: #e3f2fd;
}

.snowy-bg {
  background-color: #e0f2f1;
}

.default-bg {
  background-color: #f5f5f5;
}

/* 地图容器 */
.map-container {
  margin: 30px 0;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  text-align: center;
}

#map {
  width: 100%;
  height: 400px;
  margin-top: 10px;
}
</style>
